import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";

//ANT DESIGN IMPORTS
import { Input, Row, Card, Form, DatePicker, Col, Divider, Spin } from "antd";

//PROJECT IMPORTS
import Close from "./Close";
import ApproveGroupSavings from "./Approve";
import UndoApproval from "./UndoApproval";
import Reject from "./Reject";
import ModifyApplication from "./ModifyApplication";
import Activate from "./Activate";
import Withdraw from "./Withdraw";
import Deposit from "./Deposit";
import UnassignOfficer from "./UnassignOfficer";
import AssignOfficer from "./AssignOfficer";
import WithdrawnByApplicant from "./WithdrawnByClient";
import AddCharge from "./AddCharge";
import PostInterestAsOn from "./PostInterestAsOn";
import ManageAccount from "./ManageAccount";
import Kyc from "./Kyc";
import HoldSavingsAcc from "./HoldSavingsAcc";
import TransferFunds from "./TransferFunds";

const GsimAccountMainActionPage = (props) => {
  const { userData } = props;
  const { state } = useLocation();

  useEffect(() => {
    // console.log(state);
  }, []);

  const renderActions = () => {
    switch (state?.actionLabel?.toLowerCase()) {
      case "modify application":
        return <ModifyApplication userData={userData} />;
      case "reject":
        return <Reject userData={userData} />;
      case "approve":
        return <ApproveGroupSavings userData={userData} />;
      case "undo approval":
        return <UndoApproval userData={userData} />;
      case "withdraw":
        return <Withdraw userData={userData} />;
      case "deposit":
        return <Deposit userData={userData} />;
      case "close":
        return <Close userData={userData} />;
      case "activate":
        return (
          <Activate userData={userData} pageTitleParam={state?.actionLabel} />
        );
      case "assign officer":
        return <AssignOfficer userData={userData} />;
      case "unassign officer":
        return <UnassignOfficer userData={userData} />;

      case "withdrawn by client":
        return <WithdrawnByApplicant userData={userData} />;
      case "add charge":
        return <AddCharge userData={userData} />;
      case "post interest as on":
        return <PostInterestAsOn userData={userData} />;
      case "manage account":
        return <ManageAccount userData={userData} />;
      case "kyc":
        return <Kyc userData={userData} />;
      case "hold":
        return <HoldSavingsAcc userData={userData} />;
      case "unhold":
        return <HoldSavingsAcc userData={userData} />;
      case "transfer funds":
        return <TransferFunds userData={userData} />;

      default:
        return <>No {state.actionLabel} Component found contact dev</>;
    }
  };
  return <>{renderActions()}</>;
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
export default connect(mapStateToProps, null)(GsimAccountMainActionPage);
